import zhCn from './zh-cn'
import en from './en'

export default {
  zh: zhCn,
  en
}
